<template>
  <div>
    <div style="height:590px">
      <div class="sct-head">
        <i class="el-icon-document-copy"></i> 我的合同
        <div class="tip">
          合同数量 <span class="span-count">{{ all_ct }}</span> ，<!-- 我的合同
          <span class="span-count">{{ my_ct }}</span> -->
          待审批合同<span class="span-count"> {{ aboveme_ct }}</span>
        </div>
      </div>
      <div class="sct-head-search">
        <el-select
          v-model="value"
          @change="contractChange"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="search_value"
          placeholder="甲乙方id / 创建者id"
          style="width:500px"
        >
          <el-button
            type="success"
            slot="append"
            icon="el-icon-search"
            style="background-color:rgb(6, 217, 149);color:#fff;"
            @click="searchContract"
          ></el-button>
        </el-input>
      </div>
      <div class="sct-body">
        <template>
          <el-table
            :data="tableData"
            border
            style="width: 100%"
            max-height="300"
          >
            <el-table-column prop="PartA" label="甲方" width="150">
            </el-table-column>
            <el-table-column prop="PartB" label="乙方" width="150">
            </el-table-column>
            <!-- <el-table-column prop="request_no" label="请求号" width="300">
            </el-table-column> -->
            <el-table-column prop="contract_no" label="合同号" width="300">
            </el-table-column>
            <el-table-column
              prop="content"
              align="center"
              label="合同正文"
              width="120"
            >
              <template slot-scope="scope">
                <el-button
                  @click="handleClick('look', scope.row)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
                <!-- <el-button type="text" size="small">编辑</el-button> -->
              </template>
            </el-table-column>
            <!-- <el-table-column prop="goods" label="合约商品" width="120">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
              </template>
            </el-table-column> -->
            <!-- <el-table-column prop="status" label="合约标识" width="120">
      </el-table-column> -->
            <!-- <el-table-column prop="view_base_info" label="基础资料" width="100">
      </el-table-column>

      <el-table-column prop="view_sales" label="销量" width="100">
      </el-table-column>
      <el-table-column prop="view_stock" label="库存" width="100">
      </el-table-column>
      <el-table-column prop="alter_base_info" label="基础资料" width="100">
      </el-table-column> -->

            <el-table-column prop="start_time" label="开始日期" width="200">
            </el-table-column>
            <el-table-column prop="expire_in" label="结束日期" width="200">
            </el-table-column>
            <el-table-column prop="create_id" label="创建者" width="200">
            </el-table-column>
            <el-table-column prop="create_time" label="创建日期" width="200">
            </el-table-column>
            <el-table-column prop="oper_id" label="修改者" width="200">
            </el-table-column>
            <el-table-column prop="oper_time" label="修改日期" width="200">
            </el-table-column>
            <el-table-column
              fixed="right"
              prop="status"
              label="合同状态"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              align="center"
              width="200"
            >
              <template slot-scope="scope">
                <el-button
                  @click="handleClick('modify', scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <!-- <el-button type="text" size="small">编辑</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
// import { unixPermissions } from "jszip/lib/defaults";

export default {
  name: "ctable",
  inject: ["QueryContract"],
  data() {
    return {
      search_value: "",
      all_ct: 0,
      my_ct: 0,
      aboveme_ct: 0,
     /*  //修改、查看合同
      DialogVisible: false,
      //查看合同正文
      contractBDVisible: false, */
      options: [
        {
          value: "1",
          label: "全部"
        },
        {
          value: "2",
          label: "我的合约"
        },
        {
          value: "3",
          label: "我相关的合约"
        },
        /* {
          value: "4",
          label: "审核中"
        } */
      ],

      value: "1",
      tableData: [],
      all_data: []
    };
  },
  mounted() {
    this.searchContractList();
  },
  methods: {
    /**
     * @param {e} 触发时改变的值
     * @function contractChange
     * @desc 选择框改变触发函数
     */
    contractChange(e) {
      console.log(e);
      const create_id = localStorage.getItem("user_id");
      switch (e) {
        case "1":
          this.tableData = [];
          this.tableData = this.all_data;
          break;
        case "2":
          this.tableData = [];
          this.all_data.forEach((item, index, arr) => {
            if (item.create_id == create_id) {
              this.tableData.push(item);
            }
          });
          break;
        case "3":
          this.tableData = [];
          this.all_data.forEach((item, index, arr) => {
            if (item.create_id == create_id||item.oper_id == create_id) {
              this.tableData.push(item);
            }
          });
          break;
        /* case "4":
          if()
          break; */
      }
    },
    handleClick(key, row) {
      if (key == "modify") {
        this.$emit("showContract",{
          key,row
        });
      } else if (key == "look") {
        this.$emit("showContract",{
          key,row
        });
      }
    },
    searchContract() {
      if(this.search_value==""||this.search_value.length==0){
        this.tableData=this.all_data;
      }
      const table_data = [];
      var that = this;
      this.tableData.forEach((item,index,arr)=>{
        if(item.PartA.indexOf(this.search_value)>-1||item.PartB.indexOf(this.search_value)>-1||item.create_id.indexOf(this.search_value)>-1){
          table_data.push(item);
        }
      })
      this.tableData = table_data;
    },
    async searchContractList() {
      const res = await this.QueryContract();
      console.log("获取所有合约：", res);
      console.log(JSON.stringify(res.data.resp_data));
      this.tableData = res.data.resp_data;
      this.all_data = res.data.resp_data;
      this.all_ct = this.tableData.length;
      var count = 0;
      this.tableData.forEach((item, index, arr) => {
        if (item.status == 0) {
          count++;
        }
      });
      this.aboveme_ct = count;
    }
  }
};
</script>
<style scoped>
.sct-head {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  background-color: rgb(250, 250, 249);
  padding: 10px;
  color: #000;
  font-weight: 700;
  border: 1px solid #ebeef5;
}
.el-icon-document-copy {
  font-size: 20px;
  color: rgb(6, 217, 149);
  margin-right: 10px;
}
.sct-head-search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 60px;
  background-color: #fff;
  border: 1px solid #ebeef5;
  margin-top: -1px;
  padding: 0 20px;
}
.sct-body {
  width: 100%;
  height: 300px;
  max-height: calc(100% - 120px);
  /* background-color: pink; */
  padding: 20px 0;
}
.tip {
  width: auto;
  background-color: rgba(5, 250, 123, 0.079);
  margin-left: 20px;
  padding: 2px 40px 2px 20px;
  border: 1px solid rgba(18, 226, 56, 0.69);
  color: #909399;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 400;
}
.span-count {
  color: rgba(18, 226, 56, 0.69);
}
</style>
